import { Component } from '@angular/core';

import { DeviceDetector } from '../shared/services/device-detector.service';

/**
 * Component that displays a list of app tiles in a section.
 */
@Component({
    selector: 'ohp-app-tiles-section',
    templateUrl: './app-tiles-section.component.html'
})
export class AppTilesSectionComponent {

    public isMobile: boolean;

    constructor(
        deviceDetector: DeviceDetector
    ) {
        this.isMobile = deviceDetector.isMobileDevice();
    }
}
